{
  "step": "Step {{current}} / {{total}}",
  "back": "Back",
  "useDefault": "Use the default and continue",
  "recommended": "Recommended",
  "next": "Next",
  "finish": "Finish",
  "saving": "Saving...",
  "submitError": "Could not save — try again.",
  "businessType": {
    "title": "What's your business type?",
    "help": "Decides which bookkeeping forms you can export later; changeable in Settings.",
    "household": "Household business",
    "unregistered": "Not registered",
    "enterprise": "Enterprise"
  },
  "defaultChargeAbsent": {
    "title": "Are no-notice absences billed?",
    "help": "Applies to per-session students you add later; each one can be changed individually.",
    "yes": "Billed",
    "no": "Not billed"
  },
  "maxExcusedPerMonth": {
    "title": "How many excused absences per month?",
    "help": "Beyond this, the next excused absence counts as a no-notice one; a made-up session refunds the allowance.",
    "three": "3 sessions",
    "two": "2 sessions",
    "four": "4 sessions",
    "unlimited": "No limit"
  },
  "invoiceDueDay": {
    "title": "When are invoices due?",
    "help": "Past the due date the invoice shows \"n days late\" and lands on the Needs attention card.",
    "plus7": "7 days after sending",
    "day5": "The 5th of each month",
    "day10": "The 10th of each month",
    "day15": "The 15th of each month"
  },
  "classMode": {
    "title": "How do you organize classes?",
    "help": "Only sets screen defaults, changeable later in Settings › Display. Both styles use the same billing.",
    "cohort": "Group classes",
    "cohortDesc": "The whole class follows one lesson, meeting on fixed days each week. Maths, languages, exam prep.",
    "individual": "One-on-one",
    "individualDesc": "Each student has their own pace, scheduled by time slot. Instruments, art, private tutoring.",
    "presetHeading": "This sets",
    "presetPrimaryButton": "Main button",
    "presetPrimaryButtonValue": "Create class",
    "presetForm": "Create class form",
    "presetFormCohort": "Pick multiple days a week, class name required",
    "presetFormIndividual": "One day a week, class name can stay blank",
    "presetSkeleton": "Weekly schedule",
    "presetSkeletonCohort": "A class with two or more time slots gets a colour",
    "presetSkeletonIndividual": "Plain background, one card per time slot",
    "presetStudents": "Students list",
    "presetStudentsCohort": "Shows the class column and filter",
    "presetStudentsIndividual": "Hides the class column, filter still available"
  }
}
